import { useMemo } from "react";

import { DonutChart, Table } from "@similarweb/pro-logic-components";
import { Flex } from "@similarweb/ui-components/foundations";

import type { EDataType } from "../../advertisers/overview/components/types";

import { CHANNEL_CONFIG } from "./constants";
import { getTableColumnDefinition, getTrackedActivityDonutChartConfig } from "./TrackedActivityEstimatesConfigs";
import type { IChartData } from "./types";

interface ITabContentProps {
    metricType: EDataType;
    chartData: IChartData[];
    onChannelClick: (channelId: string) => void;
}

export const TabContent = ({ chartData, metricType, onChannelClick }: ITabContentProps) => {
    const tableColumns = useMemo(
        () => getTableColumnDefinition(metricType, onChannelClick),
        [metricType, onChannelClick],
    );

    const chartDataWithoutComingSoon = useMemo(
        () => chartData.filter((item) => !CHANNEL_CONFIG[item.id]?.hasNoMetricData),
        [chartData],
    );

    const chartConfig = useMemo(() => getTrackedActivityDonutChartConfig(metricType), [metricType]);

    return (
        <Flex
            alignItems="center"
            gap="24px"
            margin="24px 40px"
        >
            <DonutChart
                innerSize="60%"
                shouldPresentLegend={false}
                config={chartConfig}
                data={[{ data: chartDataWithoutComingSoon }]}
            />
            <Flex
                flexDirection="column"
                maxWidth="560px"
                flex="1"
            >
                <Table
                    data={chartData}
                    columnConfig={tableColumns}
                    isLoading={false}
                    theme="white"
                    bordersConfig={{ body: false, header: false, rowBorders: false }}
                    rowHoverable={false}
                />
            </Flex>
        </Flex>
    );
};
